import { atom } from 'jotai';

export const progressionAtom = atom<number>(0);
